// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".submit-request-page{background-color:var(--light-blue)}", "",{"version":3,"sources":["webpack://./src/components/pages/all-inclusives/submit-request/style.scss"],"names":[],"mappings":"AAAA,qBACE,kCAAA","sourcesContent":[".submit-request-page {\n  background-color: var(--light-blue);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
